import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "x", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Number = _resolveComponent("Number")!
  const _component_Space = _resolveComponent("Space")!
  const _component_Fieldset = _resolveComponent("Fieldset")!

  return (_openBlock(), _createBlock(_component_Fieldset, { label: "分割" }, {
    default: _withCtx(() => [
      _createVNode(_component_Space, null, {
        default: _withCtx(() => [
          _createVNode(_component_Number, {
            "model-value": _ctx.modelValue[0],
            min: 1,
            style: {"width":"100px"},
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', [$event, _ctx.modelValue[1]])))
          }, null, 8 /* PROPS */, ["model-value"]),
          _hoisted_1,
          _createVNode(_component_Number, {
            "model-value": _ctx.modelValue[1],
            min: 1,
            style: {"width":"100px"},
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', [_ctx.modelValue[0], $event])))
          }, null, 8 /* PROPS */, ["model-value"])
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }))
}